<template>
    <div class="announcement">
        <b-modal title="Announcement - Metal Market" class="modal-primary" ok-only size="lg" v-model="announcementModal" @ok="closeAnnouncement()">
        <div class="row">
            <div class="col-12">
            <h6>New Updates</h6>
            <br/>
            <table class="table table-bordered table-striped table-sm">
                <tbody>
                <tr>
                    <td>
                    <div class="ql-editor" v-html='announcementContent'>
                    </div>
                    </td>  
                </tr>
                </tbody>
            </table>
            </div>
        </div>
        </b-modal>
    </div>
</template>

<script>
  export default {
    name: 'announcement',
    data () {
      return {
        announcementModal: false,
        announcementContent: ''
      }
    },
    methods: {
      getAnnouncementDetails () {
        console.log('getAnnouncementDetails -> getAnnouncementDetails')
        this.$http.get('admin/announcement-content').then(response => {
          this.announcementModal = true
          this.announcementContent = response.body[0]['setting_value']
        }, response => {
          console.log(response)
        })
      },
      closeAnnouncement () {
        this.announcementModal = false
        this.close()
      },
      close () {
        console.log('close method called')
        this.$auth.user().is_update = 0
      }
    },
    created () {
      this.$bus.$on('show-announcement', ($event) => {
        this.getAnnouncementDetails()
      })
    },
    beforeMount () {
      console.log('beforeMount -> this.$auth.user()', this.$auth.user().is_update)
      // called when announcement is made
      if (this.$auth.user().is_update === 1) {
        this.userCheckedIn(this.$auth.user().id)
        this.getAnnouncementDetails()
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/Announcement.vue